import type { ExpressConfirmationBody } from '../api/types'

export const EXPRESS_API_PATHS = {
  check: '/vendor-products/express-check',
} as const

export const EXPRESS_CONFIRMATION_REQUIRED = 'EXPRESS_CONFIRMATION_REQUIRED'

export const EXPRESS_REASON = {
  noVendorInRange: 'NO_VENDOR_IN_RANGE',
  notExpressEligible: 'NOT_EXPRESS_ELIGIBLE',
  expressAvailable: 'EXPRESS_AVAILABLE',
} as const

export type ExpressReason = (typeof EXPRESS_REASON)[keyof typeof EXPRESS_REASON]

export const EXPRESS_SHIPMENT_MODE = {
  express: 'express',
  standard: 'standard',
} as const

export type ExpressShipmentMode =
  (typeof EXPRESS_SHIPMENT_MODE)[keyof typeof EXPRESS_SHIPMENT_MODE]

export type ExpressConfirmDialogProps = {
  confirmation: ExpressConfirmationBody
  submitting: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const EXPRESS_UI = {
  checking: 'Checking 60-minute delivery for your address…',
  checkingTitle: 'Checking delivery',
  available: 'A nearby vendor can deliver this in about 60 minutes.',
  splitAvailable:
    'Some items can arrive in 60 minutes. Standard items can be scheduled.',
  standardHint: 'This order uses standard delivery from tomorrow. Pick a slot over the next 7 days.',
  standardReadyHint:
    'These items use standard delivery from tomorrow. Pick a slot below over the next 7 days.',
  shipmentExpressTitle: 'Express delivery',
  sameDayBadge: 'Same day',
  shipmentExpressHint:
    'A nearby vendor can deliver these in about 60 minutes, or you can pick a slot from today through the next 7 days.',
  shipmentStandardTitle: 'Standard delivery',
  shipmentStandardHint: 'These items ship as a separate standard order you can schedule.',
  confirmTitle: 'Proceed without 60-minute delivery?',
  confirmLead:
    'Some items cannot be delivered in 60 minutes because no vendor is nearby.',
  confirmProceed: 'Proceed with standard delivery',
  confirmCancel: 'Go back',
  closeAria: 'Close',
  dialogLabel: '60-minute delivery confirmation',
} as const
